import { action } from 'satcheljs';

export const subscribeToInboxPlusRowNotifications = action(
    'SUBSCRIBE_TO_INBOX_PLUS_ROW_NOTIFICATIONS'
);
